import { useEffect, useState } from 'react'

/** The current time, refreshed every minute, for "waiting 2h 13m" and similar. */
export function useNow(every = 60_000) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), every)
    return () => clearInterval(t)
  }, [every])
  return now
}
